import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { ApolloLink } from 'apollo-link';
import localforage from 'localforage';

import { baseUrl } from '../utils/globals';

const apolloCache = new InMemoryCache();

const httpLink = createHttpLink({
  uri: `${baseUrl}/graphql`,
});

// Global token variable in order to cache the token
let token = null;
const authLink = setContext(async (_, { headers }) => {
  if (!token) {
    const user = await localforage.getItem('user');
    console.log('Apollo Client Auth - localforage called!');
    if (user) ({ token } = user);
  }
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const apolloClient = new ApolloClient({
  cache: apolloCache,
  link: ApolloLink.from([authLink, httpLink]),
});

// Reset token on logout where resetstore is called
apolloClient.onResetStore(() => {
  console.log('Apollo Client onResetStore callback called!');
  token = null;
});

export default apolloClient;



// WEBPACK FOOTER //
// ./src/graphql/apolloClient.js